import React, { useState } from 'react';
import { Button } from './ui/Button';
import { Input } from './ui/Input';
import { ArrowRight, Check, Loader2 } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface WaitlistFormProps {
  showCheckbox?: boolean;
  className?: string;
  buttonText?: string;
}
export function WaitlistForm({
  showCheckbox = false,
  className = '',
  buttonText = 'Join the waitlist'
}: WaitlistFormProps) {
  const [email, setEmail] = useState('');
  const [hasAppleWatch, setHasAppleWatch] = useState(false);
  const [status, setStatus] = useState<'idle' | 'loading' | 'success'>('idle');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;
    setStatus('loading');
    // Simulate API call
    setTimeout(() => {
      setStatus('success');
      setEmail('');
    }, 1500);
  };
  return <div className={`w-full max-w-md ${className}`} data-id="element-156">
      <AnimatePresence mode="wait" data-id="element-157">
        {status === 'success' ? <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -10
      }} className="flex flex-col items-center justify-center p-6 bg-teal-50 rounded-2xl border border-teal-100 text-center" data-id="element-158">
            <div className="h-12 w-12 bg-teal-100 rounded-full flex items-center justify-center mb-3" data-id="element-159">
              <Check className="h-6 w-6 text-teal-600" data-id="element-160" />
            </div>
            <h3 className="text-lg font-semibold text-teal-900" data-id="element-161">
              You're on the list!
            </h3>
            <p className="text-teal-700 text-sm" data-id="element-162">
              We'll notify you when Vytaniq is ready.
            </p>
            <Button variant="ghost" className="mt-4 text-teal-700 hover:text-teal-900 hover:bg-teal-100" onClick={() => setStatus('idle')} data-id="element-163">
              Add another email
            </Button>
          </motion.div> : <motion.form initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onSubmit={handleSubmit} className="flex flex-col gap-3" data-id="element-164">
            <div className="flex flex-col sm:flex-row gap-3" data-id="element-165">
              <Input type="email" placeholder="Enter your email" value={email} onChange={e => setEmail(e.target.value)} required className="flex-1" disabled={status === 'loading'} data-id="element-166" />
              <Button type="submit" disabled={status === 'loading'} className="min-w-[140px]" data-id="element-167">
                {status === 'loading' ? <Loader2 className="h-4 w-4 animate-spin" data-id="element-168" /> : <>
                    {buttonText} <ArrowRight className="ml-2 h-4 w-4" data-id="element-169" />
                  </>}
              </Button>
            </div>

            {showCheckbox && <div className="flex items-center space-x-2 ml-1" data-id="element-170">
                <input type="checkbox" id="apple-watch" checked={hasAppleWatch} onChange={e => setHasAppleWatch(e.target.checked)} className="h-4 w-4 rounded border-slate-300 text-teal-600 focus:ring-teal-600" data-id="element-171" />
                <label htmlFor="apple-watch" className="text-sm text-slate-600 leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70" data-id="element-172">
                  I use an Apple Watch
                </label>
              </div>}

            <p className="text-xs text-slate-500 ml-1" data-id="element-173">
              Google Fit supported • Apple Health coming soon
            </p>
          </motion.form>}
      </AnimatePresence>
    </div>;
}